import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-rule-statistics',
  templateUrl: './rule-statistics.component.html',
  styleUrls: ['./rule-statistics.component.scss']
})
export class RuleStatisticsComponent implements OnInit {
  @Input() count;
  @Input() failed;
  @Input() success;
  constructor() { }

  ngOnInit() {
  }

  isNaN(number) {
    return isNaN(number);
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/rules-list/rule-statistics/rule-statistics.component.ts